module.exports = __webpack_public_path__ + "img/services.1385f691.svg";